import React, {Fragment, useState, useEffect} from 'react';
import ERPFormService from "../../../../services/ERPFormService";
import Color from "color";

const TemplateErpCatnat = (props) => {
    const erpFormSrevice = new ERPFormService()
    const [items, setItems] = useState([])

    useEffect(()=>{
        (props.insee)?getCatnatAPI(props.insee):null;

    },[])

    const getCatnatAPI = (insee)=>{

        const url = 'https://www.georisques.gouv.fr/api/v1/gaspar/catnat?code_insee='+insee+'&page=1&page_size=10'

        axios.get(url).then((result)=>{
            (result.data.data )?setItems(result.data.data):null
        }, err=>{console.log(err)})
    }

    const renderItem=(item, index)=>{
        return(
            <tr key={index}>
                <td className="text-left">{item.libelle_risque_jo}</td>
                <td className="text-center">{item.date_debut_evt}</td>
                <td className="text-center">{item.date_fin_evt}</td>
                <td className="text-center">{item.date_publication_jo}</td>
                <td></td>
            </tr>
        )
    }

    return (
        <div className="ue-section">
            <div className="ue-section ue-section-title" style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                <span >DÉCLARATION DE SINISTRES INDÉMNISÉS</span>
            </div>
            <br/>
                <h6 className="text-center">
                    en application des articles L 125-5 et R125-26 du Code de l'environnement
                </h6>
                <hr/>
                <br/>
                <p className={"erp-catnat mention text-left"}>
                    Sinistres indemnisés dans le cadre d'une reconnaissance de l'état de catastrophe.<br/>
                    Le vendeur ou bailleur coche les cases « indemnisé » dans l'annexe jointe si il a connaissance d'une indemnisation suite à des dommages, sur l'immeuble, provoqués par un/des événements listés en annexe.<br/>
                    Le vendeur/bailleur ainsi que l’acquéreur/vendeur<br/>
                </p>
                <br/>
                <br/>
                <h3 className="text-center">Arrêtés CATNAT</h3>
                <br/>
                <table className="ue-form-table-base">
                    <thead style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                        <tr>
                            <th width={240}>Risque</th>
                            <th className="text-center">Début</th>
                            <th className="text-center">Fin</th>
                            <th className="text-center">JO</th>
                            <th className="text-center">Indemnisé</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        (items)
                        ?Object.values(items).map((item,index)=>{
                            return renderItem(item, index)
                         })
                       :<tr><td colSpan={5} className={'text-center'}>Pas de données disponibles</td></tr>
                    }
                    </tbody>
                </table>
                <br/>
                <div   className="text-right" style={{"marginTop":"50px"}}>
                        <p  style={{"marginBottom": "50px"}}>
                            Fait le __/__/____ <br/><br/>
                            A _______________________________________
                        </p>
                        <br/>
                        <div  style={{"textAlign": "left"}}>Nom et visa du vendeur ou du bailleur</div>
                        <div style={{"textAlign": "right"}}>Visa de l'acquéreur ou du locataire</div>
                </div>
        </div>
    );
};

export default TemplateErpCatnat;
